export default __webpack_public_path__ + "static/media/miniLogoSB.a31deaef.svg";